<template>
  <div
    class="global-chatbot-container"
    :class="{'hidden': isChatBotHidden, 'is-editor': isPresentationEditorRoute($route)}"
  >
    <div v-if="hasCloseButton" class="close-button-container">
      <aha-icon-button
        @click="closeChatbot"
        class="close-button"
        v-aha-emit-action
        name="close-chatbot-button"
      >
        <aha-icon
          name="close-v2"
          width="18"
          height="18"
          viewBox="0 0 16 16"
        />
      </aha-icon-button>
    </div>
    <AIChatbotIframe
      :src="aiChatbotUrl"
      :errorComponent="AIChatbotIframeError"
      @closePanel="closeChatbot"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import AIChatbotIframe from '@/components-v2/aha-ai/AIChatbotIframe.vue'
import AIChatbotIframeError from '@/components-v2/aha-ai/AIChatbotIframeError.vue'

export default {
  name: 'GlobalChatbotContainer',
  components: {
    AIChatbotIframe,
  },
  props: {
    hasCloseButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      AIChatbotIframeError,
    }
  },
  computed: {
    ...mapState({
      renderPresentationDetail: (state) => state.renderPresentationDetail,
      isPreview: (state) => state.isPreview,
    }),

    ...mapGetters(['isPresentationEditorRoute']),
    ...mapGetters('aiChatbot', ['canUseAIChatbot', 'aiChatbotUrl']),
    ...mapGetters('featureToggles', ['canUseAIImprovingSlideContent']),
    ...mapGetters('rightNav', ['isAITabActive']),
    ...mapGetters(['isBackstage', 'isPresenting']),

    isAIAutoPanelVisible() {
      return this.canUseAIImprovingSlideContent && this.isAITabActive
    },

    isPresentingBackstageOrPreview() {
      return this.isPresenting || this.isBackstage || this.isPreview
    },

    isChatBotHidden() {
      return !this.isAIAutoPanelVisible
        || !this.renderPresentationDetail
        || !this.isPresentationEditorRoute(this.$route)
        || this.isPresentingBackstageOrPreview
    },
  },
  methods: {
    ...mapActions('rightNav', ['setRightNavActiveTabAction']),

    closeChatbot() {
      this.setRightNavActiveTabAction('')
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.global-chatbot-container {
  position: fixed;
  bottom: 0;
  right: 20px;
  width: 400px;
  height: 600px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 38px rgba(82, 95, 127, 0.12);
  border: 1px solid #e5e7eb;
  z-index: 9999;

  &.is-editor {
    position: absolute;
    top: calc($editor-header-height + 0.75rem);
    right: calc($right-nav-width + 9px);
    width: calc($right-panel-width - 2px);
    height: calc(100% - $editor-header-height - 3.5rem);
    border-radius: 0.5rem;
    border: none;
    box-shadow: none;
    z-index: 1;
  }

  .close-button-container {
    @apply absolute right-0;
    padding: 0 12px;
    top: 8.5px;

    .close-button {
      width: 32px;
      height: 32px;
      color: rgba(0,0,0,0.88);
      &:hover {
        background-color: rgba(0,0,0,0.04);
        color: rgba(0,0,0,0.88);
      }
      &:not(:disabled):focus-visible, &:not(:disabled):focus, &:not(:disabled):active, &:not(:disabled):focus-within {
        outline: 3px solid #91caff;
        outline-offset: 1px;
        transition: outline-offset 0s, outline 0s;
        background-color: #ffffff;
        box-shadow: none;
      }
    }
  }
}
</style>
